import React from 'react';

export const AuthenticationContext = React.createContext<any>(null);

export const TenantContext = React.createContext<any>(null);
